/* eslint-disable react/no-danger */
import React, { FunctionComponent, useEffect, useRef } from 'react';
import { siteDomain } from '@trello/config';

// eslint-disable-next-line no-restricted-imports
import { CommentDataModel } from 'app/gamma/src/types/models';

import { TrelloMarkdownWrapper } from './TrelloMarkdownWrapper';
// eslint-disable-next-line no-restricted-imports
import { defaultStore } from 'app/gamma/src/defaultStore';
// eslint-disable-next-line @trello/no-module-logic
export const markdown = new TrelloMarkdownWrapper(defaultStore);

import styles from './TrelloMarkdown.less';
import classNames from 'classnames';
import { applyBidiTooltip } from './applyBidiTooltip';

export enum MarkdownContentType {
  Comment,
  Description,
  CheckItems,
  Bio,
}

interface AllProps {
  text: string;
  contentType: MarkdownContentType;
  options?: CommentDataModel;
  className?: string;
}

export const TrelloMarkdown: FunctionComponent<AllProps> = ({
  text,
  contentType,
  options,
  className,
}) => {
  let formattedContent: string;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      applyBidiTooltip(ref.current);
    }
  }, []);

  switch (contentType) {
    case MarkdownContentType.Comment:
      formattedContent = markdown.comments.format(text, {
        siteDomain: siteDomain,
        ...options,
      }).output;
      break;
    case MarkdownContentType.Description:
      formattedContent = markdown.description.format(text, options).output;
      break;
    case MarkdownContentType.CheckItems:
      formattedContent = markdown.checkItems.format(text, options).output;
      break;
    case MarkdownContentType.Bio:
      formattedContent = markdown.bio.format(text, options).output;
      break;
    default:
      throw new Error('Invalid MarkdownContentType for MarkdownContainer.');
  }

  return (
    <div
      className={classNames(styles.markdown, className)}
      ref={ref}
      dangerouslySetInnerHTML={{
        __html: formattedContent,
      }}
    />
  );
};
